import Fetch, { pageInfo } from './fetch';
import Qs from 'qs'

const common = {
   /**
    * 获取园区树
    **/
    querySchoolHouseTree(schoolId) {
        return Fetch({
            url: '/basic/querySchoolHouseTree?schoolId=' + schoolId,
            method: 'get'
        });
    },
    /**
    * 根据楼栋查楼层下拉
    **/
    getFloorListByHouseId(id) {
        return Fetch({
            url: '/floor/getFloorListByHouseId?houseId=' + id,
            method: 'get'
        });
    },
    /**
    * 根据学院院系结构树
    **/
    querySchoolRelationTree(id) {
        return Fetch({
            url: '/school/querySchoolRelationTree?schoolId=' + id,
            method: 'get'
        });
    },
    schoolRelationTreeWithoutClass(id) {
        return Fetch({
            url: '/school/schoolRelationTreeWithoutClass?schoolId=' + id,
            method: 'get'
        });
    },

    /**
    * 考情状态下拉
    **/
    getChildItems() {
        return Fetch({
            url: '/baseConfig/getChildItems?parentCode=kaoqin_status',
            method: 'get'
        });
    },
    /**
    * 根据学院查系
    **/
    querySchoolDepartment(param) {
        return Fetch({
            url: '/school/querySchoolDepartment?' + Qs.stringify(param),
            method: 'get'
        });
    },

     /**
     * 获取导入完成状态
     * */
    getImportStatus (param) {
        return Fetch({
            url: '/importData/getImportStatus?' + Qs.stringify(param),
            method: 'get',
            headers: { showLoading: false }
        });
    },
    /**
     * 获取导出完成状态

     * */
    getExportStatus (key, value) {
        return Fetch({
            url: '/exportData/getImportStatus?key=' + key + '&value=' + value,
            method: 'get',
            headers: { showLoading: false }
        });
    },
    /**
     * 获取导出文件
    * */
    downloadFailFile (filepath) {
        return Fetch({
            //url: '/exportData/downloadFailFile?filePath=' +filepath,
             url:'/oss/d/'+filepath,
            method: 'get',
            responseType: 'arraybuffer',
            headers: { showLoading: false }
        });
    },
    /**
    * 获取导出文件
   * */
    getSchoolKaoqinDevice () {
        return Fetch({
            url: '/school/getSchoolKaoqinDevice',
            method: 'get',
        });
    },

}

export default common;



// WEBPACK FOOTER //
// ./src/api/common.js